import { focusFirstInteractive } from "./modal_focus";

// Assign a button to open a modal. The button can be anywhere, but the modal should be at the bottom of the page
// Accepts two selectors formatted as strings (e.g. ".class-name" or "#id-name")
const setUpModal = (openSelector, modalSelector) => {
    const openButton = document.querySelector(openSelector);
    const modal = document.querySelector(modalSelector);
    const xCloseButton = modal.querySelector(".vb-modal__x-close-button");
    const closeButton = modal.querySelector(".vb-modal__close-button");
    // Open the modal by clicking the open button; focusing and pressing enter also registers as a click for anchor tags
    openButton?.addEventListener("click", (e) => {
        openModal(e, modal);
    })
    openButton?.addEventListener("keydown", (e) => {
        if (e.key === "Enter") {
            openModal(e, modal);
        }
    })
    // Close the modal by clicking outside the content of the modal
    modal.addEventListener("click", (e) => {
        if (e.target.classList.contains("vb-modal")) {
            closeModal(modal);
        }
    })
    // Close the modal by pressing "Escape"
    document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
            closeModal(modal);
        }
    })
    // Close the modal by pressing the "X" button
    xCloseButton.addEventListener("click", (e) => {
        closeModal(modal);
    })
    // Close the modal by pressing the close button if it exists
    closeButton?.addEventListener("click", (e) => {
        closeModal(modal);
    })
}

const openModal = (e, modal) => {
    e.preventDefault();
    modal.showModal();
    requestAnimationFrame(() => focusFirstInteractive(modal));
}

const closeModal = (modal) => {
    modal.close();
}

const externalOpenModal = (modalSelector) => {
    const modal = document.querySelector(modalSelector);
    modal.showModal();
    requestAnimationFrame(() => focusFirstInteractive(modal));
}

window.openModal = externalOpenModal;
window.setUpModal = setUpModal;
